// PARTNER-FAHRER-EINLADEN-KONTAKT-001 (Owner 15.09.2026) — eingeladen wird NUR mit E-Mail-Adresse oder
// Telefonnummer, nie mit einem Namen. Diese Vorprüfung spart nur den Server-Umweg bei offensichtlichen
// Fehleingaben; die verbindliche Prüfung und die Suche nach dem Fahrer macht POST /partners/invite-driver.
export const CONTACT_HINT = 'Bitte eine E-Mail-Adresse oder Telefonnummer eingeben — mit einem Namen kann nicht eingeladen werden.';

export function inviteContactKind(raw) {
  const value = String(raw || '').trim();
  if (!value) return null;
  if (value.includes('@')) return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value) ? 'email' : null;
  // Gleiche Trennzeichen wie der Server (routes/partners.js INVITE_PHONE_CHARS_RE, lib/sms.js): auch
  // typografische Striche aus Kontakte-App/PDF (U+2010–U+2015, U+2212) — sonst blockt das Portal eine gültige Nummer.
  if (!/^[+\d(][\d\s()./\u2010-\u2015\u2212-]*$/.test(value)) return null;
  return value.replace(/\D/g, '').length >= 6 ? 'phone' : null;
}

export default inviteContactKind;
